
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"check"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"#fff"}}),_c('path',{attrs:{"d":"M6.442 10.34l2.168 2.167-.014-.014 4.891-4.891","stroke":"#000"}})]),_c('circle',{attrs:{"cx":"10","cy":"10","r":"9","fill":"currentColor","mask":"url(#check)","stroke":"currentColor"}})])
          )
        }
      }
    